// small PKCE helper to generate verifier & challenge
export async function generatePKCE() {
    const verifier = base64UrlEncode(crypto.getRandomValues(new Uint8Array(32)));
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    const challenge = base64UrlEncode(new Uint8Array(digest));
    return { verifier, challenge };
}

function base64UrlEncode(buffer: Uint8Array) {
    // standard base64, then URL-safe
    return btoa(String.fromCharCode(...Array.from(buffer)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}
